import cx from 'classnames'
import * as React from 'react'

import Spacer from '../spacer'
import { SpacingProps } from '../spacer/spacer'
import styles from './notice.module.scss'

export type Props = {
  type: 'info' | 'warning' | 'plain' | 'success'
  title?: string
  className?: string
  children?: React.ReactNode | string
  fullWidth?: boolean
} & SpacingProps

export default function Notice(props: Props) {
  const { children, className, title, type, ...otherProps } = props

  const classNames = cx(
    {
      [styles.root]: true,
      [styles[`type-${type}`]]: true,
    },

    className,
  )

  return (
    <Spacer {...otherProps} className={classNames}>
      {title != null && <span className={styles.title}>{title}</span>}
      {children}
    </Spacer>
  )
}
